module.exports = __webpack_public_path__ + "img/img29.a23990dc.svg";